import styles from '../Legal.module.css';

const sections = [
  { title: '1. Information we collect', text: 'We collect information you provide directly, such as your name and email when you submit the contact form, along with basic usage data collected through analytics.' },
  { title: '2. How we use information', text: 'We use collected information to respond to inquiries, improve the product, and understand how visitors use our pages. We do not sell personal information.' },
  { title: '3. Data storage', text: 'Form submissions are stored in our Firestore database and retained only as long as needed to respond to your inquiry or as required by law.' },
  { title: '4. Cookies & analytics', text: 'We use privacy-conscious analytics to understand aggregate traffic patterns. You can disable cookies in your browser settings at any time.' },
  { title: '5. Your rights', text: 'You may request access to, correction of, or deletion of your personal data at any time by contacting us through the Get in Touch page.' },
  { title: '6. Changes to this notice', text: 'We may update this notice periodically. Material changes will be reflected by an updated effective date at the top of this page.' },
];

export default function Privacy() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.wrap}`}>
        <span className={styles.eyebrow}>Legal</span>
        <h1 className={styles.title}>Privacy Notice</h1>
        <p className={styles.updated}>Effective date: January 1, 2026</p>
        <p className={styles.intro}>
          This notice explains what information Solvora collects, how it's used, and the
          choices you have. It applies to all pages on this site.
        </p>
        {sections.map((s) => (
          <div key={s.title} className={styles.block}>
            <h2 className={styles.h2}>{s.title}</h2>
            <p className={styles.p}>{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
